import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'CpeConfiguration' })({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '12px 16px 12px 32px',
        gap: 12
    },
    container: {
        display: 'flex',
        alignItems: 'stretch',
        gap: 24
    },
    caption: {
        marginLeft: -8
    },
    line: {
        background: '#F5726A',
        width: 2
    },
    items: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 6
    },
    operator: {
        position: 'relative',
        left: -25,
        transform: 'translateX(-50%)'
    }
});
